const STATUS = {
  SOLICITADO: 1,
  RESERVADO: 2,
  SUBSIDIO_LIQUIDADO: 3,
  APROVADO: 4,
  MINUTA_A_VALIDAR: 5,
  MINUTA_REPROVADA: 6,
  MINUTA_APROVADA: 7,
  AGUARDANDO_ASSINATURA_DO_CERTIFICADO: 8,
  CERTIFICADO_ASSINADO: 9,
  CERTIFICADO_APROVADO: 10,
  CERTIFICADO_ENTREGUE: 11,
  CONTRATO_ASSINADO: 12,
  CONTRATO_REGISTRADO: 13,
  PROTOCOLADO: 14,
  EM_ANALISE: 15,
  INCONFORME: 17,
  AGUARDANDO_AUTORIZACAO: 18,
  EMPENHANDO: 19,
  EMPENHADO: 20,
  CONTRATO_GERADO: 21,
  EM_ASSINATURA_DA_CONSTRUTORA: 22,
  AGUARDANDO_PAGAMENTO: 23,
  EM_ASSINATURA_DO_GABINETE: 25,
  PRAZO_DOSSIE_VENCIDO: 26,
  PRAZO_DOSSIE_PRORROGADO: 27,
  PRAZO_DOSSIE_VENCIDO_PRORROGACAO: 28,
  INDEFERIDO: 99,
};

const NOME_POR_STATUS = {
  [STATUS.SOLICITADO]: 'SOLICITADO',
  [STATUS.RESERVADO]: 'RESERVADO',
  [STATUS.PROTOCOLADO]: 'PROTOCOLADO',
  [STATUS.EM_ANALISE]: 'EM ANÁLISE',
  [STATUS.INCONFORME]: 'INCONFORME',
  [STATUS.AGUARDANDO_AUTORIZACAO]: 'AGUARDANDO AUTORIZAÇÃO',
  [STATUS.EMPENHANDO]: 'EMPENHANDO',
  [STATUS.EMPENHADO]: 'EMPENHADO',
  [STATUS.CONTRATO_GERADO]: 'CONTRATO GERADO',
  [STATUS.EM_ASSINATURA_DA_CONSTRUTORA]: 'EM ASSINATURA (CONSTRUTORA)',
  [STATUS.EM_ASSINATURA_DO_GABINETE]: 'EM ASSINATURA (GABINETE)',
  [STATUS.AGUARDANDO_PAGAMENTO]: 'AGUARDANDO PAGAMENTO',
  [STATUS.SUBSIDIO_LIQUIDADO]: 'SUBSÍDIO LIQUIDADO',
  [STATUS.PRAZO_DOSSIE_VENCIDO]: 'PRAZO DOSSIÊ VENCIDO',
  [STATUS.PRAZO_DOSSIE_PRORROGADO]: 'PRAZO DOSSIÊ PRORROGADO',
  [STATUS.PRAZO_DOSSIE_VENCIDO_PRORROGACAO]: 'PRAZO DOSSIÊ VENCIDO PRORROGAÇÃO',
  [STATUS.INDEFERIDO]: 'INDEFERIDO',
};

const STATUS_POR_NOME = Object.entries(NOME_POR_STATUS).reduce(
  (acc, [status, nome]) => {
    acc[nome] = Number(status);
    return acc;
  },
  {},
);

export function obterNomeDoStatus(status) {
  return NOME_POR_STATUS[status] || null;
}

export function obterStatusPorNome(nome) {
  return STATUS_POR_NOME[nome] || null;
}

const CORES_POR_STATUS = {
  [STATUS.SOLICITADO]: 'Azul',
  [STATUS.RESERVADO]: 'Azul',
  [STATUS.PROTOCOLADO]: 'Azul',
  [STATUS.EM_ANALISE]: 'Azul',
  [STATUS.EMPENHANDO]: 'Azul',
  [STATUS.EMPENHADO]: 'Azul',
  [STATUS.CONTRATO_GERADO]: 'Azul',
  [STATUS.PRAZO_DOSSIE_PRORROGADO]: 'Azul',
  [STATUS.MINUTA_APROVADA]: 'Azul',
  [STATUS.APROVADO]: 'Azul',
  [STATUS.CERTIFICADO_ASSINADO]: 'Azul',
  [STATUS.CERTIFICADO_APROVADO]: 'Azul',
  [STATUS.CONTRATO_ASSINADO]: 'Azul',
  [STATUS.CONTRATO_REGISTRADO]: 'Azul',

  [STATUS.INCONFORME]: 'Laranja',
  [STATUS.AGUARDANDO_AUTORIZACAO]: 'Laranja',
  [STATUS.EM_ASSINATURA_DA_CONSTRUTORA]: 'Laranja',
  [STATUS.EM_ASSINATURA_DO_GABINETE]: 'Laranja',
  [STATUS.AGUARDANDO_ASSINATURA_DO_CERTIFICADO]: 'Laranja',
  [STATUS.AGUARDANDO_PAGAMENTO]: 'Laranja',
  [STATUS.AGUARDANDO_ASSINATURA_DO_CERTIFICADO]: 'Laranja',
  [STATUS.MINUTA_A_VALIDAR]: 'Laranja',

  [STATUS.SUBSIDIO_LIQUIDADO]: 'Verde',
  [STATUS.CERTIFICADO_ENTREGUE]: 'Verde',

  [STATUS.INDEFERIDO]: 'Vermelho',
  [STATUS.MINUTA_REPROVADA]: 'Vermelho',

  [STATUS.PRAZO_DOSSIE_VENCIDO]: 'Vinho',
  [STATUS.PRAZO_DOSSIE_VENCIDO_PRORROGACAO]: 'Vinho',
};

const STATUS_DE_ERRO = [STATUS.INDEFERIDO, STATUS.MINUTA_REPROVADA];

const SETOR_ORIGEM_POR_STATUS = {
  [STATUS.SOLICITADO]: 'Construtora / Corretor',
  [STATUS.RESERVADO]: 'Diretoria administrativa',
  [STATUS.INCONFORME]: 'Contratos',
  [STATUS.AGUARDANDO_AUTORIZACAO]: 'Contratos',
  [STATUS.EMPENHANDO]: 'Gabinete',
  [STATUS.EMPENHADO]: 'Diretoria administrativa',
  [STATUS.EM_ASSINATURA_DO_GABINETE]: 'Contratos',
  [STATUS.EM_ASSINATURA_DA_CONSTRUTORA]: 'Contratos',
  [STATUS.AGUARDANDO_PAGAMENTO]: 'Gabinete',
};

const SETOR_DESTINO_POR_STATUS = {
  [STATUS.SOLICITADO]: 'Diretoria administrativa',
  [STATUS.RESERVADO]: 'Construtora / Corretor',
  [STATUS.PROTOCOLADO]: 'Contratos',
  [STATUS.EM_ANALISE]: 'Contratos',
  [STATUS.INCONFORME]: 'Construtora / Corretor',
  [STATUS.AGUARDANDO_AUTORIZACAO]: 'Gabinete',
  [STATUS.EMPENHANDO]: 'Diretoria administrativa',
  [STATUS.EMPENHADO]: 'Contratos',
  [STATUS.CONTRATO_GERADO]: 'Contratos',
  [STATUS.EM_ASSINATURA_DO_GABINETE]: 'Gabinete',
  [STATUS.EM_ASSINATURA_DA_CONSTRUTORA]: 'Construtora / Corretor',
  [STATUS.AGUARDANDO_PAGAMENTO]: 'Diretoria administrativa',
  [STATUS.SUBSIDIO_LIQUIDADO]: 'Diretoria administrativa',
  [STATUS.INDEFERIDO]: 'Contratos',
  [STATUS.PRAZO_DOSSIE_PRORROGADO]: 'Diretoria administrativa',
};

const MENSAGEM_POR_STATUS = {
  [STATUS.SOLICITADO]:
    'Solicitação registrada pela construtora. Aguardando análise cadastral para reserva do subsídio.',
  [STATUS.RESERVADO]:
    'Subsídio reservado para o proponente. A construtora tem 120 dias para enviar o contrato da Caixa e o dossiê completo.',
  [STATUS.EM_ANALISE]:
    'Documentação em conferência com os dados do contrato da Caixa.',
  [STATUS.INCONFORME]:
    'Documentação com pendências. Devolvida à construtora para correção e reenvio.',
  [STATUS.EMPENHANDO]:
    'Autorização da presidência recebida. Processo encaminhado à Diretoria de Administração.',
  [STATUS.EMPENHADO]:
    'Empenho emitido no SPF. Processo liberado para a geração do contrato.',
  [STATUS.CONTRATO_GERADO]:
    'Contrato gerado com o número do empenho. Pronto para a coleta de assinaturas.',
  [STATUS.EM_ASSINATURA_DA_CONSTRUTORA]:
    'Contrato com a construtora para coleta das assinaturas do proponente.',
  [STATUS.EM_ASSINATURA_DO_GABINETE]:
    'Contrato no gabinete, aguardando a assinatura da presidência.',
  [STATUS.AGUARDANDO_PAGAMENTO]:
    'Contrato assinado. Pagamento do subsídio na fila do setor administrativo.',
  [STATUS.INDEFERIDO]:
    'Solicitação indeferida. Processo encerrado sem concessão do subsídio.',
};

function formatarData(data) {
  if (!data) return null;
  const dataFormatada = new Date(data);
  if (Number.isNaN(dataFormatada.getTime())) return null;
  return dataFormatada.toLocaleDateString('pt-BR');
}

function obterMensagemDeProtocolado(dataDocumental) {
  const dataFormatada = formatarData(dataDocumental);

  if (!dataFormatada) {
    return 'Documentação recebida e protocolada.';
  }

  return `Documentação recebida em ${dataFormatada} e protocolada.`;
}

function obterMensagemDeAguardandoAutorizacao(numeroDoProcesso) {
  if (!numeroDoProcesso) {
    return 'Documentação conforme. Encaminhado ao gabinete para autorização.';
  }

  return `Documentação conforme. NUP ${numeroDoProcesso} cadastrado. Encaminhado ao gabinete para autorização.`;
}

export function formatarOperacaoBancaria(
  ordemBancaria,
  ordemBancariaComplementar,
  separador = ' e ',
) {
  if (!ordemBancaria) return null;
  if (!ordemBancariaComplementar) return ordemBancaria;
  return `${ordemBancaria}${separador}${ordemBancariaComplementar}`;
}

function obterMensagemDeSubsidioLiquidado(informacoesDoPagamento) {
  if (!informacoesDoPagamento) {
    return 'Pagamento efetuado no SPF. Subsídio liquidado e baixa registrada no Habix.';
  }

  const { OrdemBancaria, OrdemBancariaComplementar, DataDoPagamento } =
    informacoesDoPagamento;
  const dataFormatada = formatarData(DataDoPagamento);
  const operacaoBancaria = formatarOperacaoBancaria(
    OrdemBancaria,
    OrdemBancariaComplementar,
  );

  if (!operacaoBancaria && !dataFormatada) {
    return 'Pagamento efetuado no SPF. Subsídio liquidado e baixa registrada no Habix.';
  }

  const rotulo = OrdemBancariaComplementar
    ? 'Ordens bancárias'
    : 'Ordem bancária';

  return `Pagamento efetuado no SPF. ${rotulo} ${operacaoBancaria} em ${dataFormatada}. Subsídio liquidado e baixa registrada no Habix.`;
}

function obterMensagemDeProrrogacao(prazoDoDossie) {
  if (!prazoDoDossie) return null;

  const dataDoOficio = formatarData(prazoDoDossie.DataDeRecebimentoDoOficio);
  const novaData = formatarData(prazoDoDossie.NovaDataDeVencimento);

  return `Prorrogação aprovada com base no ofício da construtora recebido em ${dataDoOficio}. Novo prazo até ${novaData}. Protocolo do recebimento liberado.`;
}

function obterMensagemDeVencimentoDoPrazo(prazoDoDossie) {
  if (!prazoDoDossie) return null;

  const dataDeVencimento = formatarData(prazoDoDossie.DataDeVencimentoOriginal);

  return `Prazo do dossiê venceu em ${dataDeVencimento} (120 dias sem o protocolo do recebimento). A ação 'Protocolar recebimento' fica bloqueada até a Diretoria Administrativa aprovar uma prorrogação.`;
}

function obterMensagemDeVencimentoAposProrrogacao(prazoDoDossie) {
  if (!prazoDoDossie) return null;

  const dataDeVencimento = formatarData(prazoDoDossie.NovaDataDeVencimento);

  return `O prazo prorrogado também venceu em ${dataDeVencimento} (180 dias no total). Não há nova prorrogação disponível. A única ação possível é indeferir a solicitação.`;
}

export function obterMensagemDoStatus(
  status,
  informacoesDoPagamento,
  numeroDoProcesso,
  dataDocumental,
  prazoDoDossie,
) {
  if (status === STATUS.SUBSIDIO_LIQUIDADO) {
    return obterMensagemDeSubsidioLiquidado(informacoesDoPagamento);
  }
  if (status === STATUS.PROTOCOLADO) {
    return obterMensagemDeProtocolado(dataDocumental);
  }
  if (status === STATUS.AGUARDANDO_AUTORIZACAO) {
    return obterMensagemDeAguardandoAutorizacao(numeroDoProcesso);
  }
  if (status === STATUS.PRAZO_DOSSIE_PRORROGADO) {
    return obterMensagemDeProrrogacao(prazoDoDossie);
  }
  if (status === STATUS.PRAZO_DOSSIE_VENCIDO) {
    return obterMensagemDeVencimentoDoPrazo(prazoDoDossie);
  }
  if (status === STATUS.PRAZO_DOSSIE_VENCIDO_PRORROGACAO) {
    return obterMensagemDeVencimentoAposProrrogacao(prazoDoDossie);
  }
  return MENSAGEM_POR_STATUS[status] || null;
}

export function obterSetorOrigemDoStatus(status) {
  return SETOR_ORIGEM_POR_STATUS[status] || null;
}

export function obterSetorDestinoDoStatus(status) {
  return SETOR_DESTINO_POR_STATUS[status] || null;
}

export function statusEhDeErro(status) {
  return STATUS_DE_ERRO.includes(status);
}

export default function obterCorDoStatusDaSolicitacao(statusDaSolicitacao) {
  return CORES_POR_STATUS[statusDaSolicitacao] || 'Vermelho';
}

export { STATUS };




// WEBPACK FOOTER //
// ./src/utils/statusDaSolicitacao.js